module.exports = __webpack_public_path__ + "img/55.1b6442cb.png";